import { styled } from "@mui/material";

export const Headband = styled("div")`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  border-radius: ${(props) => props.theme.spacing(0.5)};

  ${(props) => props.theme.breakpoints.down("sm")} {
    margin: ${(props) => props.theme.spacing(1)};
    margin-bottom: ${(props) => props.theme.spacing(5)};
    border-radius: ${(props) => props.theme.spacing(0.5)};
  }
`;
